
import { defineComponent, ref, useAttrs, computed } from "vue";
import Camera from "simple-vue-camera";
interface StyleAttributes {
  defaultBorder?: string;
  borderColor?: string;
  borderWidth?: string;
  borderStyle?: string;
  padding?: string;
  margin?: string;
}
export default defineComponent({
  components: {
    camera: Camera,
  },
  props: {
    isPreview: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const cameraRef = ref<InstanceType<typeof Camera>>();
    const imageSrc = ref("");
    const snapshot = async () => {
      const blob = await cameraRef.value?.snapshot();

      // To show the screenshot with an image tag, create a url
      if (blob) {
        imageSrc.value = URL.createObjectURL(blob);
      }
    };
    const attrs = useAttrs();
    const dynamicAttrs = computed(() => {
      const clonedAttrs = { ...attrs };
      const styleAttrs = clonedAttrs.style as StyleAttributes;

      // Check if attrs.style.defaultBorder is "true !important"
      if (styleAttrs && styleAttrs.defaultBorder === "true !important") {
        styleAttrs.borderColor = "";
        styleAttrs.borderWidth = "";
        styleAttrs.borderStyle = "";
        styleAttrs.padding = "";
        styleAttrs.margin = "";
        clonedAttrs.borderColor = "";
        clonedAttrs.borderWidth = "";
        clonedAttrs.borderStyle = "";
        clonedAttrs.padding = "";
        clonedAttrs.margin = "";
      }

      return clonedAttrs;
    });
    return {
      cameraRef,
      snapshot,
      imageSrc,
      dynamicAttrs,
    };
  },
});
